import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PsychologyAltIcon(props: IconProps) {
    return <Icon {...props} iconKey={"psychology_alt"}/>
}
